/**
 * Нерозривні пробіли там, де рядок не має рватися:
 * - перед тире — інакше рядок починається з «— корпоративне…»;
 * - між «№» і номером — «№ 781» не розпадається на два рядки;
 * - після однолітерних слів (і, й, в, у, з, а, о) — вони не висять у кінці
 *   рядка окремо від слова, до якого належать.
 *
 * Лише для рядків: розмітку (посилання, <strong>) не чіпаємо. Результат
 * однаковий у пререндері й у браузері, тож гідрації це не заважає.
 *
 * Однолітерні слова заміняються двома проходами, а не lookbehind: у «і в
 * місті» перший прохід забирає пробіл перед «в», а lookbehind у регулярних
 * виразах старий Safari не розбирає взагалі — і впав би весь бандл.
 */
const SHORT = /(^|[\s («])([іійвузаоІЙВУЗАО]) (?=\S)/g;

export const tie = (value) => {
  if (typeof value !== 'string') return value;
  return value
    .replace(/ (—|–)/g, ' $1')
    .replace(/№ (?=\d)/g, '№ ')
    .replace(SHORT, '$1$2 ')
    .replace(SHORT, '$1$2 ');
};

export default tie;
